/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  loadingOrganizations: {
    id: 'organization-switch.list.loading',
    defaultMessage: 'Loading organizations...',
  },
  errorLoadingOrganizations: {
    id: 'organization-switch.list.error-loading',
    defaultMessage: 'An error occurred while loading the organization list. Try again later.',
  },
  organizationListAriaLabel: {
    id: 'organization-switch.list.aria-label',
    defaultMessage: 'Organization list',
  },
  manageOrganizationsButton: {
    id: 'organization-switch.list.manage-organizations-button',
    defaultMessage: 'Manage organizations',
  },
})
